//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { newMediaTypes } from '@motionelements/core/src/helpers/newMediaTypes.js';

import newMediaTypesMixin from '@/components/mixins/new-mediatypes.mixin.js';

export default {
  name: 'SubmissionCategories',
  mixins: [newMediaTypesMixin],
  props: {
    channelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      faCheck,
    };
  },
  computed: {
    categoriesLists() {
      return {
        graphic: [
            this.$t('contributor.submission.category.new_years_cards'),
            this.$t('contributor.submission.category.leaflets'),
            this.$t('contributor.submission.category.letters'),
            this.$t('contributor.submission.category.flyers'),
            this.$t('contributor.submission.category.invitations'),
            this.$t('contributor.submission.category.posters'),
            this.$t('contributor.submission.category.brochure'),
            this.$t('contributor.submission.category.coupons'),
            this.$t('contributor.submission.category.birthday_cards'),
            this.$t('contributor.submission.category.emails'),
            this.$t('contributor.submission.category.logo'),
            this.$t('contributor.submission.category.instagram_stories'),
            this.$t('contributor.submission.category.zoom_background'),
            this.$t('contributor.submission.category.youtube_thumbnail'),
            this.$t('contributor.submission.category.youtube_channel_art'),
            this.$t('contributor.submission.category.other'),
          ],
        notion: [
            this.$t('contributor.submission.category.planning'),
            this.$t('contributor.submission.category.design'),
            this.$t('contributor.submission.category.education'),
            this.$t('contributor.submission.category.marketing'),
            this.$t('contributor.submission.category.task_lists'),
            this.$t('contributor.submission.category.personal'),
            this.$t('contributor.submission.category.notion_ai'),
            this.$t('contributor.submission.category.other'),
          ],
        ui: [
            this.$t('contributor.submission.category.ui_kits'),
            this.$t('contributor.submission.category.wireframes'),
            this.$t('contributor.submission.category.mobile'),
            this.$t('contributor.submission.category.web_design'),
            this.$t('contributor.submission.category.mockups'),
            this.$t('contributor.submission.category.design_systems'),
            this.$t('contributor.submission.category.buttons'),
            this.$t('contributor.submission.category.other'),
          ],
        presentation: [
            this.$t('contributor.submission.category.business'),
            this.$t('contributor.submission.category.education'),
            this.$t('contributor.submission.category.pitch'),
            this.$t('contributor.submission.category.marketing'),
            this.$t('contributor.submission.category.medical'),
            this.$t('contributor.submission.category.startup'),
            this.$t('contributor.submission.category.design_materials'),
            this.$t('contributor.submission.category.other'),
          ],
        image_prompt: [
            this.$t('contributor.submission.category.adobe_firefly'),
            this.$t('contributor.submission.category.dall_e'),
            this.$t('contributor.submission.category.leonardo_ai'),
            this.$t('contributor.submission.category.midjourney'),
            this.$t('contributor.submission.category.niji_journey'),
            this.$t('contributor.submission.category.novel_ai'),
            this.$t('contributor.submission.category.stable_diffusion'),
          ],
      };
    },
    currentMediaType() {
      return newMediaTypes.find(({ id }) => this.channelId === id);
    },
    currentCategoriesList() {
      return _.get(this.categoriesLists, this.channelId);
    },
    acceptedApps() {
      return _.get(this.currentMediaType, 'specifications.acceptedApps', []).join(', ');
    },
  },
  methods: {
    helpCenterMediaTypeLink() {
      return this.$link('https://help.motionelements.com/contributor/docs/guide-for-selling-image-prompts').url();
    },
  },
};
